<template>

<core-panel>

	<template v-slot:head>

		<h1>Publishers</h1>

		<p>The publishers with the best average rating. Excludes expansions.</p>

	</template>

	<template v-slot:body>

		<app-person v-for="(item, index) in publishers" :hideCount="true" gamesCountProperty="gamesCount" :item="item" type="publisher" v-bind:key="index" v-on:more="onMoreClick" :dark="true" />

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'publishers',
			publishers: []
		}

	},

	methods: {

		response: function(json) {

			this.publishers = json.publishers

		},

		onMoreClick: function(id) {

			this.$pubsub.$emit('panel.open', {
				type: 'insightsRatingsPublisher',
				id: id,
				child: true
			})

		}

	}

}

</script>